import { cn } from "@/lib/utils";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";
import defaultLogo from "@/assets/images/oskar-logo.svg";
import darkLogo from "@/assets/images/oskar-logo-dark.svg";

import { Avatar, AvatarImage } from "./ui/avatar";

export interface ULThemeLogoProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Optional image url of the logo.
   */
  imageUrl?: string;
  /**
   * Alt Text for the logo image
   */
  altText: string;
  /**
   * Optional Classes for custom overrides
   */
  className?: string;
}

const ULThemeLogo = ({
  imageUrl,
  altText,
  className,
  ...rest
}: ULThemeLogoProps) => {
  // Using extractTokenValue utility to extract the logo URL, Logo Visible flags from CSS variable
  const themedLogoSrcValue = extractTokenValue("--ul-theme-widget-logo-url");
  const isLogoHidden =
    extractTokenValue("--ul-theme-widget-logo-position") === "none";
  const themedStylesAvatar = "flex flex-wrap justify-widget-logo w-full";
  const themedStylesAvatarImg = "h-(--height-widget-logo) max-w-full object-contain";
  const isDark = document.documentElement.classList.contains("dark");
  const logoSrc = themedLogoSrcValue || imageUrl || (isDark ? darkLogo : defaultLogo);

  return (
    !isLogoHidden && (
      <div className={cn(themedStylesAvatar, className)}>
        <Avatar className="w-auto h-auto max-w-full rounded-none">
          <AvatarImage
            src={logoSrc}
            alt={altText}
            className={cn(themedStylesAvatarImg)}
            loading="eager"
            decoding="async"
            fetchPriority="high"
            {...rest}
          />
        </Avatar>
      </div>
    )
  );
};
export default ULThemeLogo;
